// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1136":"e4788a38","5134":"d5f08ba0"}[chunkId] + ".chunk.css";
};